  <mat-card class="dialogTemplate" data-backdrop="static"  >
  <div  mat-dialog-content>
    <h5>El cambio de dosis no corresponde al cálculo realizado según Ficha Técnica, consulte la dosis seleccionada</h5>
</div>
<div mat-dialog-actions>
  <button class="dialogButton" mat-raised-button (click)="onNoClick()">Acceptor</button>
</div>
</mat-card>